import React, { Component } from "react";
import ProductHeader from "../ProductDetails/ProductHeader";
import { connect } from "react-redux";
import Product from "./Product";
import ActionButton from "../ActionButton";

import { fetchCategory } from "../../store/actions/store";
import LoadingGrid from "./LoadingGrid";
import Category from "./Category";
import CategoryV2 from "./CategoryV2";
import PasswordPage from "./PasswordPage";
import CircularProgress from "@material-ui/core/CircularProgress";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

import { Helmet } from "react-helmet";
import { Divider } from "@material-ui/core";

class CategoryDetailList extends Component {
  state = {
    didRequest: false,
    token: null,
  };

  handleDialogContinue = () => {
    this.props.history.push("/cart");
  };
  handleDialogClaimItems = () => {
    let products = this.state.pending_items;
    this.props.history.replace(
      `/product/${products[0].category}/${
        products[0].parent ? products[0].parent + "/" : ""
      }${products[0].slug}`,
      { pending_items: products.slice(1) }
    );
  };
  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.setState({ loaded: true });
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const windowHeight =
      "innerHeight" in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    const windowBottom = windowHeight + window.pageYOffset;
    if (Math.ceil(windowBottom) >= docHeight / 2) {
      let selectedCategory = this.props.categories.find(
        (cat) => cat.slug == this.props.match.params.categorySlug
      );
      let params = {
        slug: this.props.match.params.categorySlug,
        category_id: selectedCategory?.id,
        country_code: this.props.country_code,
        isBranchBased: this.props.settings.is_branch_based_ordering,
        type: !this.props.branch.isPickup ? "delivery" : "pickup",
        bdc_id: !this.props.branch.isPickup
          ? this.props.branch.bdc
          : this.props.branch.branch,
        totalPages: selectedCategory.pages || null,
      };

      if (
        selectedCategory.pages_loaded < selectedCategory.pages &&
        !this.props.categoryLoading &&
        selectedCategory.has_loaded
      )
        this.props.fetchCategory(params, selectedCategory.pages_loaded + 1);
    } else {
      // console.log("not at bottom");
    }
  };

  componentDidUpdate = async (prevProps) => {
    // window.scrollTo(0, 0);

    // this.props.fetchCategory(window.location.pathname.split("/")[2]);
    let selectedCategory;
    try {
      selectedCategory = this.props.categories.find(
        (cat) => cat.slug == this.props.match.params.categorySlug
      );

      if (
        !selectedCategory.has_loaded &&
        !selectedCategory.has_children &&
        !this.state.didRequest &&
        !selectedCategory.has_password &&
        !this.props.categoryLoading
      ) {
        let params = {};
        if (
          this.props.settings.is_branch_based_ordering &&
          (this.props.branch.branch || this.props.branch.bdc)
        ) {
          params = {
            category_id: selectedCategory?.id,
            slug: this.props.match.params.categorySlug,
            isBranchBased: this.props.settings.is_branch_based_ordering,
            type: !this.props.branch.isPickup ? "delivery" : "pickup",
            bdc_id: !this.props.branch.isPickup
              ? this.props.branch.bdc
              : this.props.branch.branch,
            country_code: this.props.country_code,
          };
        } else {
          params = {
            category_id: selectedCategory?.id,
            slug: this.props.match.params.categorySlug,
            country_code: this.props.country_code,
          };
        }
        if (this.state.token) {
          params["token"] = this.state.token;
        }
        this.setState({ didRequest: true, token: null });
        await this.props.fetchCategory(params);
        this.setState({ didRequest: false, token: null });
      }
    } catch {}
  };

  validationSuccess = (token, category_id) => {
    this.props.removeCategoryPassword(category_id);
    this.setState({ token });
  };
  getMetaDescription = (selectedCategory) => {
    if (!selectedCategory) return "";

    return (
      selectedCategory.meta_description?.substring(0, 160) ||
      selectedCategory.name
    );
  };
  getMetaTitle = (selectedCategory) => {
    const { language } = this.props;
    if (!selectedCategory) return "";
    if (language === "arabic") {
      return (
        selectedCategory.meta_name?.substring(0, 160) ||
        selectedCategory.ar_name ||
        selectedCategory.name
      );
    }
    return (
      selectedCategory.meta_name?.substring(0, 160) || selectedCategory.name
    );
  };
  render() {
    const { language, second_loading, cart, settings } = this.props;
    let customTexts = settings.custom_texts;
    const storeLayout = settings.store_layout;
    let totalCartLength = cart.cart.length + cart.promo_items.length;

    if (!customTexts) {
      customTexts = {
        review_order: "Review Order",
        review_order_ar: "مراجعة الطلب",
      };
    }

    let products;
    let subCategories;
    let selectedCategory;

    try {
      selectedCategory = this.props.categories.find(
        (cat) => cat.slug == this.props.match.params.categorySlug
      );
      if (selectedCategory.has_password) {
        return (
          <PasswordPage
            category={selectedCategory}
            onValidation={(token) =>
              this.validationSuccess(token, selectedCategory.id)
            }
          />
        );
      }
      if (!selectedCategory.has_loaded && !selectedCategory.has_children) {
        return (
          <div
            className=""
            style={{ backgroundColor: "white", minHeight: window.innerHeight }}
          >
            <ProductHeader
              enableSearch={true}
              title={
                language == "english"
                  ? selectedCategory.name
                  : selectedCategory.ar_name
              }
              selectedCategory={selectedCategory}
              onBack={() => {
                const parentCategory = this.props.categories?.find((cat) =>
                  cat.sub_categories.includes(selectedCategory.id)
                );
                if (parentCategory) {
                  this.props.history.replace(
                    "/category/" + parentCategory.slug
                  );
                } else this.props.history.replace("/");
              }}
            />

            <div
              className="free-space-80"
              style={{ backgroundColor: "white" }}
            ></div>

            <LoadingGrid cellHeight={260} settings={settings} />
          </div>
        );
      }

      if (!selectedCategory.has_children) {
        let tempProducts = selectedCategory.products;
        if (
          selectedCategory.pages_loaded === 1 &&
          !["newest", "most-selling", "discount-products"].includes(
            selectedCategory.id
          ) &&
          !settings.enable_products_random_sort &&
          !settings.sort_products_by_inventory
        ) {
          tempProducts = tempProducts.sort((a, b) => {
            if (a.sort_order < b.sort_order) return -1;
            if (a.sort_order > b.sort_order) return 1;
            if (a.name && b.name) return a.name.localeCompare(b.name);
            return 0;
          });
        }
        products = tempProducts.map((product) => (
          <Product
            category_id={selectedCategory.id}
            key={
              "gird_category_item " +
              product.name +
              " " +
              product.id +
              parseInt(Math.random() * 1000)
            }
            product={product}
            productInCategoryDetails={true}
          />
        ));
      } else {
        subCategories = this.props.categories.filter((cat) =>
          selectedCategory.sub_categories.includes(cat.id)
        );
        subCategories = subCategories.map((category, indx) =>
          storeLayout == "grid" ? (
            <Category
              key={"Grid_Category " + category.name + category.id}
              image={
                category.photo_medium
                  ? category.photo_medium
                  : category.photo
                  ? category.photo
                  : null
              }
              name={language == "english" ? category.name : category.ar_name}
              numberOfProducts={category.products_count}
              slug={category.slug}
              min_order={category.minimum_order_value}
              settings={this.props.settings}
              language={language}
              history={this.props.history}
            />
          ) : (
            <CategoryV2
              key={"Grid_Category2 " + category.name + category.id}
              image={
                category.photo_medium
                  ? category.photo_medium
                  : category.photo
                  ? category.photo
                  : null
              }
              name={language == "english" ? category.name : category.ar_name}
              numberOfProducts={category.products_count}
              min_order={category.minimum_order_value}
              settings={this.props.settings}
              slug={category.slug}
              history={this.props.history}
              language={language}
              description={
                language === "arabic"
                  ? category.ar_description?.trim() || ""
                  : category.description?.trim() || ""
              }
            />
          )
        );
      }
    } catch (err) {
      this.props.history.replace("/");
      return null;
    }

    const autoPlayDelay = settings?.auto_play_delay;
    const hasCoverPhoto =
      selectedCategory?.cover_photo_large || selectedCategory?.cover_photo
        ? true
        : false;

    let images = [
      <div key="Main Photo">
        <img
          src={
            hasCoverPhoto
              ? selectedCategory?.cover_photo_large ||
                selectedCategory?.cover_photo
              : null
          }
          style={{
            objectFit: "cover",
            height: 300,
          }}
        />
      </div>,
    ];
    return (
      <div
        className=""
        style={{
          backgroundColor: "white",
          minHeight: window.innerHeight,
          overflowY: "scroll",
        }}
      >
        <Helmet>
          <title>{this.getMetaTitle(selectedCategory)}</title>
          <meta
            name="description"
            content={this.getMetaDescription(selectedCategory)}
          />
          <link rel="canonical" href={window.location.href} />
        </Helmet>
        <ProductHeader
          enableSearch={true}
          title={
            language == "english"
              ? selectedCategory.name
              : selectedCategory.ar_name
          }
          selectedCategory={selectedCategory}
          onBack={() => {
            const parentCategory = this.props.categories?.find((cat) =>
              cat.sub_categories.includes(selectedCategory.id)
            );
            if (parentCategory) {
              this.props.history.replace("/category/" + parentCategory.slug);
            } else {
              this.props.history.replace("/");
            }
          }}
        />
        {selectedCategory && hasCoverPhoto && (
          <div style={{ marginTop: window.innerWidth > 768 ? 54 : 20 }}>
            <Carousel
              autoPlay={autoPlayDelay > 0}
              infiniteLoop={images.length > 1}
              showThumbs={false}
              preventMovementUntilSwipeScrollTolerances
              showStatus={false}
              showIndicators={false}
              interval={autoPlayDelay * 1000 || 3000}
            >
              {images}
            </Carousel>

            <Divider />
            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                textAlign: language == "english" ? "start" : "end",
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontWeight: 600,
                  fontSize: 18,
                }}
              >
                {language == "english"
                  ? selectedCategory.name
                  : selectedCategory.ar_name}
              </p>
              <p>{selectedCategory.description}</p>
            </div>
            <Divider />
          </div>
        )}
        {!hasCoverPhoto ? (
          <div
            className="free-space-80"
            style={{ backgroundColor: "white" }}
          ></div>
        ) : (
          <div style={{ backgroundColor: "white", height: 30 }}></div>
        )}
        {!selectedCategory.has_children ? (
          <div
            className="row mx-auto m-0"
            style={{
              backgroundColor: "white",
              width: "98%",
              backgroundColor: "white",
            }}
            dir={language == "english" ? "ltr" : "rtl"}
          >
            {products}
          </div>
        ) : (
          <div
            className={"row text-center justify-content-between m-0 w-100 ".concat(
              storeLayout == "grid2" ? "px-1" : ""
            )}
            dir={language == "english" ? "ltr" : "rtl"}
            style={{ transform: "scale(0.983)" }}
          >
            {subCategories}
          </div>
        )}

        <div
          className={"free-space-80"}
          style={{ backgroundColor: "white" }}
        ></div>

        {totalCartLength > 0 ? (
          <ActionButton
            action={
              language == "english"
                ? customTexts.review_order
                : customTexts.review_order_ar
            }
            onClick={() => {
              this.handleDialogContinue();
            }}
            total={this.props.cart.price.toFixed(settings.currency_decimals)}
            quantity={totalCartLength > 0 ? totalCartLength : null}
          />
        ) : null}
        {this.props.categoryLoading && selectedCategory.has_loaded && (
          <div
            style={{
              position: "relative",
              bottom: totalCartLength > 0 ? 70 : 35,
              direction: language == "english" ? "ltr" : "rtl",
            }}
          >
            {" "}
            <CircularProgress size={30} />{" "}
            <span
              className="mx-4"
              style={{
                color: this.props.settings.dark || "#0099cc",
                position: "relative",
                top: -9,
              }}
            >
              {language == "english"
                ? "Loading more items..."
                : "تحميل منتجات اخرى..."}
            </span>
          </div>
        )}
        {this.props.settings.is_branch_based_ordering &&
        !this.props.branch.branch &&
        totalCartLength <= 0 ? (
          <ActionButton
            action={
              customTexts
                ? language == "english"
                  ? customTexts.select_location
                  : customTexts.select_location_ar
                : language == "english"
                ? "Select your location"
                : "اختر منطقتك"
            }
            onClick={() => this.props.history.push("/select/branch")}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    categories: state.store.store.categories,
    cart: state.cart,
    branch: state.branch,
    settings: state.store.store.settings,
    discounts: state.cart.discounts,
    applied_promos: state.cart.smart_promos,
    categoryLoading: state.store.categoryLoading,
    country_code: state.currency.selected,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCategory: (params, page) => dispatch(fetchCategory(params, page)),
    removeCategoryPassword: (category_id) =>
      dispatch({ type: "REMOVE_CATEGORY_PASSWORD", payload: category_id }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CategoryDetailList);
